export default __webpack_public_path__ + "static/media/html.7ae54b9f.svg";